import React from 'react';
import _ from 'lodash';
import { useStateSelector } from '../../../../data/global/dataSelectors';
import { StatusClassMap } from './AccountManagementUpdateStatus';
import { DefaultAccountUpdateDetails } from '@tradingblock/types';

export const AccountUpdateDetails: React.FunctionComponent<{}> = () => {
  const updateDetails = useStateSelector(s => s.private.accountManagement.currentItem.details) || DefaultAccountUpdateDetails;
  let item = updateDetails.item;
  if (item === 'Flexability') {
    item = 'Flexibility';
  }
  if (updateDetails.item === 'PhoneNumber' && updateDetails.updated && updateDetails.updated.accountHolder && updateDetails.updated.accountHolder.phones && updateDetails.updated.accountHolder.phones[0]) {
    item = `${updateDetails.item.replace(/([A-Z])/g, ' $1').trim()} - ${
      updateDetails.updated.accountHolder.phones[0].type
    }`;
  }

  return (
    <>
      <div className="screen-body-section">
        <p className="fields-title">Account Update Request Type</p>
        <p className="mute">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
      </div>
    </>
  );
};
